import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

import img from '../../assets/img/hyperdrive/img.jpg';
import img1 from '../../assets/img/hyperdrive/img1.jpg';
import img2 from '../../assets/img/hyperdrive/img2.jpg';
import img3 from '../../assets/img/hyperdrive/img3.jpg';
import img4 from '../../assets/img/hyperdrive/img4.jpg';
import img5 from '../../assets/img/hyperdrive/img5.jpg';
import img6 from '../../assets/img/hyperdrive/img6.jpg';
import img7 from '../../assets/img/hyperdrive/img7.jpg';
import img8 from '../../assets/img/hyperdrive/img8.jpg';
// import img9 from '../../assets/img/lyncco/20230921_165624.jpg'
import img10 from '../../assets/img/lyncco/Untitled-1-00.jpg'
import img11 from '../../assets/img/lyncco/Untitled-1-09.jpg'
import img12 from '../../assets/img/lyncco/Untitled-18416t3874.jpg'
import img13 from '../../assets/img/lyncco/Untitled-1841o30.jpg'
import img14 from '../../assets/img/lyncco/Untitled-1871630-9.jpg'
import img15 from '../../assets/img/lyncco/fotoj.jpg'






const EventsSlider = () => {
  const images = [
    img, img1, img2, img3, img4, img5, img6, img7, img8, img10, img11, img12, img13, img14, img15
  ];

  return (
    <div className="events-slider container">
      <Swiper
        slidesPerView={3}
        spaceBetween={20}
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay]}
        breakpoints={{
          320: {
            slidesPerView: 1,
            spaceBetween: 10
          },
          768: {
            slidesPerView: 2,
            spaceBetween: 15
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 20
          }
        }}
        className="mySwiper"
      >
        {images.map((image, index) => (
          <SwiperSlide key={index}>
            <div className="border border-purple rounded-[12px] overflow-hidden">
              <img 
                className='rounded-[12px] w-full h-auto object-cover' 
                src={image} 
                alt={`Event ${index + 1}`} 
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default EventsSlider;